import { PresentationStatus } from '../types';

export type PillTone = 'neutral' | 'info' | 'warn' | 'danger';

export function pillToneForStatus(status: PresentationStatus): PillTone {
  if (status === 'review') return 'info';
  if (status === 'ready') return 'neutral';
  return 'warn';
}
